/**
 * @generated SignedSource<<5d8b9c17257280cd03c8a5fd90f8e2a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanup_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupForm_data">;
  readonly " $fragmentType": "DiskCleanup_data";
};
export type DiskCleanup_data$key = {
  readonly " $data"?: DiskCleanup_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanup_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiskCleanup_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiskCleanupForm_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "76b9d381a6f5103ebbbd53047e8fe31a";

export default node;
